import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useParams } from 'react-router-dom';
import oikosApi from '../../services/oikos'
import qs from 'qs';
import moment from 'moment';
import { getLinkEvidencia, getLinkProdFinal, downloadFile, PROD_COORDENADOR_PF_FIELDS, oikosGet } from '../../utils/fc';
import { correctionMark, correctionSegmentColor, TL_GREEN, TL_YELLOW, TL_MUTED } from '../StepStatusProduto/timelineColors';


const Circle = ( props ) => {

  if (Number(props.actual) === 9) {
    const mark = correctionMark(props.item.step, props.produto)
    const hover = {
      onMouseEnter: () => {
        props.setIsHovered(true);
        props.getStatusInfo();
      },
      onMouseLeave: () => props.setIsHovered(false),
    }
    if (mark === 'green') {
      return <i className="ri-checkbox-circle-fill text-success" {...hover} />
    }
    if (mark === 'yellow') {
      return <i className="ri-checkbox-circle-fill text-warning" {...hover} />
    }
    return <i className="ri-checkbox-blank-circle-line" style={{ color: TL_MUTED }} {...hover} />
  }

  if ((props.item.step === 4 && props.produto.prod_aprovCompliance === 1) ||
  (props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4) ||
  (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6) ||
  ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ||
  (((props.item.step === 7 || props.item.step === 6) && props.actual === 9 && props.produto.hasStatus6 !== 0)) ||
  ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ||
  (props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9))
  {
    return (
      <>
        <i className="ri-checkbox-circle-fill text-warning"
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        />
      </>
    )
  }

  if ((props.item.step === 6 || props.item.step === 7) && props.actual === 9 && props.produto.prodStatusPenultimo_id !== 6) {
    return (
      <>
        <i className="ri-checkbox-blank-circle-line"
        style={{ color: '#adb5bd' }}
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        />
      </>
    );
  }

  if (((props.item.step <= props.actual) && props.actual !== 9 && props.actual !== 1 && props.actual !== 2) ||
  (props.item.step === 1 && props.actual === 2) ||
  ((props.actual === 9) && (props.item.step === 1 || props.item.step === 2 || props.item.step === 3) && (props.produto.prodStatusPenultimo_id === 3)) ||
  ((props.actual === 9) && (props.item.step === 1 || props.item.step === 2 || props.item.step === 4) && (props.produto.prodStatusPenultimo_id === 4)) ||
  ((props.actual === 9) && (props.item.step < 7) && (props.item.step !== 4) && (props.produto.prodStatusPenultimo_id === 6)) ||
  ((props.actual === 9) && (props.item.step < 7) && (props.item.step === 4) && (props.produto.prodStatusPenultimo_id === 6) && props.produto.prod_aprovCompliance !== 1) ||
  props.actual === 7 ||
  (props.item.step === 3 && props.actual >= 3)
) {
  return (
    <>
      <i className="ri-checkbox-circle-fill text-success"
      onMouseEnter={() => {
        props.setIsHovered(true);
        props.getStatusInfo();
      }}
      onMouseLeave={() => props.setIsHovered(false)}
      />
    </>
  );
}

if ((props.item.step === (props.actual + 1) && props.actual !== 1 && props.actual !== 9 && props.actual !== 3 && props.item.step !== 3) ||
(props.actual === 3 && props.item.step === 4) ||
(props.item.step === props.actual && props.actual === 2) ||
(props.item.step === props.actual && props.actual === 1)) {
    return (
      <>
        <i className="ri-checkbox-blank-circle-line text-success"
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        >
        </i>
      </>
  );

  }

  return <i className="ri-checkbox-blank-circle-line" style={{ color: '#adb5bd' }} />;
};

Circle.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const HorizontalLineLeft = (props) => {

  return (
    <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor: Number(props.actual) === 9
        ? correctionSegmentColor(props.item.step, 'left', props.produto)
        :
      (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
      (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
      (props.actual === 3 && props.item.step === 4) ? '#339933' :
      (props.actual === 2 && props.item.step === 2) ? '#339933' :
      ((props.actual === 9) && (props.item.step < 7) && (props.item.step !== 1) && (props.produto.prodStatusPenultimo_id === 6)) ? '#339933' :
      ((props.actual === 9) && (props.item.step <= 4) && (props.produto.prodStatusPenultimo_id === 4) && (props.item.step !== 1)) ? '#339933' :
      ((props.actual === 9) && (props.item.step < 4) && (props.produto.prodStatusPenultimo_id === 3) && (props.item.step !== 1)) ? '#339933' :
      (props.actual === 9 && props.item.step > 4 && props.item.step !== 6 && props.item.step !== 7 && props.item.step !== 5) ? '#979933' :
      (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6) ? '#979933':
      ((props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4)) ? '#979933' :
      ((props.item.step === 4 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#979933' :
      ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
      (((props.item.step === 7 || props.item.step === 6 )&& props.actual === 9 && props.produto.hasStatus6 !== 0)) ? '#979933' :
      ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
      ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
      ((props.actual === 9 && props.item.step === 6) || (props.actual === 9 && props.item.step === 7)) ? '#ced4da' :
      props.item.step === 1 ? 'transparent' :
      (props.item.step <= (props.actual + 1) && props.actual !== 9  && props.actual !== 1 && props.actual !== 2 ) || (props.item.step === 7 && props.actual === 6) ? '#339933' : '#ced4da',
    }}
  />
  )
};

HorizontalLineLeft.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const HorizontalLineRight = (props) => {

  return (
    <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor: Number(props.actual) === 9
        ? correctionSegmentColor(props.item.step, 'right', props.produto)
        :
        (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
        (props.actual === 2 && props.item.step === 2) ? '#ced4da' :
        (props.actual === 9 && props.item.step > 4 && props.item.step !== 6 && props.item.step !== 7 && props.item.step !== 5) ? '#979933' :
        ((props.actual === 9 && (props.item.step === 6 || props.item.step === 5) && props.produto.hasStatus6 === 0) || (props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 === 0 )) ? '#ced4da' :
        ((props.item.step === 6 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
        (props.actual === 9 && (props.item.step === 6 || props.item.step === 5) && props.produto.hasStatus6 !== 0) ? '#979933' :
        ((props.item.step === 4 || props.item.step === 5) && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3) ? '#ced4da' :
        ((props.item.step === 5 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
        ((props.item.step === 5 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.actual === 9) ? '#979933' :
        ((props.item.step === 6 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
        (props.item.step === 1 && props.actual === 1) ? '#ced4da' :
        props.item.step === 7
          ? 'transparent'
          : (props.item.step <= props.actual)
            ? '#339933'
            : '#ced4da',
    }}
  />
  );
}

HorizontalLineRight.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Label = (props) => {

  return (
    <>
      <span
      style={{
        fontSize: 10,
        width: 70,
        textAlign: 'center',
        fontWeight: (props.item.step === (props.actual + 1) && props.actual !== 1 && props.item.step !== 3 && props.actual !== 9) ||
        (props.actual === 9 && props.item.step === 2 && props.produto.prodStatusPenultimo_id === 3) ? '600' : 'normal',
        color: Number(props.actual) === 9
          ? (correctionMark(props.item.step, props.produto) === 'green'
            ? TL_GREEN
            : correctionMark(props.item.step, props.produto) === 'yellow'
              ? TL_YELLOW
              : TL_MUTED)
          :
        ((props.actual === 9 && props.item.step === 5 && props.produto.prodStatusPenultimo_id === 4) || (props.actual === 9 && props.item.step === 7 && props.produto.prodStatusPenultimo_id === 6)) ? '#979933' :
        ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
        ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
        ((props.item.step === 4 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#979933' :
        (props.item.step === 2 && props.actual === 1) ? '#adb5bd' :
        (((props.item.step === 5 || props.item.step === 6 || props.item.step === 7) && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#adb5bd' :
        ((props.actual === 9 && (props.item.step === 6 || props.item.step === 7) && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 === 0)) ? '#ced4da' :
        (props.item.step <= props.actual && props.actual !== 9) ? '#339933' :
        ((props.actual === 9) && (props.item.step < 7) && (props.produto.prodStatusPenultimo_id === 6)) ? '#339933' :
        ((props.actual === 9) && (props.item.step <= 4) && (props.produto.prodStatusPenultimo_id === 4)) ? '#339933' :
        (props.actual === 9 && props.item.step < 4 && props.produto.prodStatusPenultimo_id === 3) ? '#339933' :
        ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
        ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.actual === 9) ? '#979933' :
        (props.item.step === (props.actual + 1) && props.actual >= 3) ? '#339933' : '#adb5bd',
      }}
      onMouseEnter={() => {
        props.setIsHovered(true);
        props.getStatusInfo();
      }}
      onMouseLeave={() => {
        props.setIsHovered(false)
      }}
      >
        {props.item.label}
      </span>

    </>
  );
}

Label.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Data = (props) => {

  const [statusData, setStatusData] = useState(null);

  useEffect(() => {
    console.log(props.produto.prodStatusAlt_data)
    /*
    axios.get(`http://localhost:3001/prodStatusAlt/${prod_id}/${props.item.step+1}`, {withCredentials: true})
     .then( result => {
       setStatusData(result.data.prodStatusAlt_data)
     })
    */
  }, [])

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

    return (
      <>
        {props.item.step < props.actual ?
          (props.produto.prodStatusAlt_data &&
            <p
            style={{
              margin: '0 auto',
              fontSize: 12,
              width: 100,
              textAlign: 'center',
              fontWeight: props.item.step === props.actual ? '600' : 'normal',
              color: props.item.step <= props.actual ? '#339933' : '#adb5bd',
            }}
          >
            {formatDate(props.produto.prodStatusAlt_data)}
          </p>
          )
          : <></>
        }
      </>
    )
}

Data.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Correcao = (props) => {
      if ((props.item.step === 5 && props.actual === 9) || (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6)) {
        return <p>Em correção interna...</p>;
      }
    }

Correcao.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Step = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [statusInfo, setStatusInfo] = useState(null);
  const [openResume, setOpenResume] = useState(false);

  const getStatusInfo = async () => {
    const res = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodStatusAlt",
          data: {
            prod_id: props.produto.prod_id,
            prodStatusTp_id: props.item.step,
            prodStatusAlt_ativo: 1,
          },
          fields: {
            '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = prodStatusAlt.prodStatusAlt_usuarioCria)': 'prod_responsavelNome',
          }
        })}`
      );

    if (res.data.length === 0) return;

    let info = res.data[0];

    if (props.item.step === 4) {
      const notas = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodComplianceAval",
          data: {
            prodStatusAlt_id: info.prodStatusAlt_id,
          }
        })}`
      );

      info = {...info, ...notas.data[0]}
    }

    if (props.item.step === 5) {
      const notas = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodGestaoAval",
          data: {
            prodStatusAlt_id: info.prodStatusAlt_id,
          }
        })}`
      );

      info = {...info, ...notas.data[0]}
    }

    setStatusInfo(info);
  }

  return (
    <Col className='text-center' style={{ padding: 0, minWidth: "50px"}}>
      <div style={{ width: '100%', height: 5, paddingTop: "7px", marginBottom: "5px" }} className="d-flex flex-row align-items-center">
        <HorizontalLineLeft {...props} />
        <Circle {...props} setIsHovered={setIsHovered} getStatusInfo={getStatusInfo}/>
        <HorizontalLineRight {...props} />
      </div>
      <Label {...props} setIsHovered={setIsHovered} getStatusInfo={getStatusInfo}/>
      {
        isHovered && statusInfo &&
        <div className='d-flex' style={{
            padding: "10px",
            textAlign:"start",
            backgroundColor: "#f1f5f7",
            position: "absolute",
            top: "40px", left: "-100px",
            zIndex: 20,
            borderRadius: "15px",
            border: "1px solid #757575",
            color: '#505a62',
            fontSize: "12px",
            minWidth: "210px",
            maxWidth: "300px",
            justifyContent: "space-between",
            fontFamily: 'Roboto, sans-serif'
          }}>
          <div className="d-flex flex-column justify-content-start">
            <span>Movimentado em: </span>
            <br />
            {(props.item.step === 4 || props.item.step === 5 || props.item.step === 7) &&
              <>
                <span>Parecer</span>
                <br />
              </>
            }
            <span>Responsável: </span>
          </div>
          <div className="d-flex flex-column justify-content-end">
            <strong className='text-right'>{moment(`${statusInfo.prodStatusAlt_data}`).format('DD/MM/YYYY')}</strong>
            <br />
            {(props.item.step === 4 || props.item.step === 5 || props.item.step === 7) &&
              <>
                {(statusInfo.prodComplianceAval_aprov === 0 || statusInfo.prodGestaoAval_aprovEP === 0 || (props.item.step === 7 && props.produto.prodStatusActual_id === 7)) ?
                  <span className='pl-2 pr-2 text-center' style={{fontSize: "10px", backgroundColor: "#bbd259", color: "#339933", borderRadius: "5px"}}>Aprovado</span> :
                  <span className='pl-2 pr-2 text-center' style={{fontSize: "10px", backgroundColor: "#fcb92c", color: "#7d5e2d", borderRadius: "5px"}}>Reprovado</span>
                }
                <br />
              </>
            }
            <strong className='text-right'>{statusInfo.prod_responsavelNome}</strong>
          </div>
        </div>
      }
    </Col>
  )
};

Step.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
};

const StepProgress = (props) => {

  const [prod, setProd] = useState(props.produto);
  const [prodFinaisLinks, setProdFinaisLinks] = useState([]);
  const [evidenceLinks, setEvidenceLinks] = useState([]);
  const [count, setCount] = useState(0);
  const [verMaisProds, setVerMaisProds] = useState(false);
  const [verMaisPareceres, setVerMaisPareceres] = useState(false);

  const getProdLatest = async () => {
    const produto = await oikosGet({
      action: 'get',
      table: 'prod',
      data: {
        prod_id: props.produto.prod_id,
        prod_ativo: 1,
      },
      fields: {
        "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
        ...PROD_COORDENADOR_PF_FIELDS,
        //'(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)': 'prodStatusTp_nome',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)':
        'prodStatusActual_id',
        "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)":
        "prodStatusPenultimo_id",
        '(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_obs',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prodStatusTp_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 3 AND psa.prodStatusAlt_ativo = 1 LIMIT 1)': 'prodStatus3_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 4 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatus4_data',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1)': 'hasStatus6',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa_PROD_ID = prod.prod_id AND psa.prodStatusTp_id = 5 AND psa.prodStatusAlt_ativo = 1)': 'hasStatus5',
      }
    });

    setProd(produto.data[0]);

    const links = await getLinkProdFinal(props.produto.prod_id);
    setProdFinaisLinks(links);

    const evidenceLinks = await getLinkEvidencia(props.produto.prod_id);
    setEvidenceLinks(evidenceLinks);
  }

  useEffect(()=>{

    getProdLatest();
    console.log(prod);
    console.log(count);

  }, [count])

  return (
    <>
      <Row style={{ marginLeft: 1, marginRight: 0 }}>
        <Step item={{ step: 1, label: 'Não Iniciado' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 2, label: 'Em Elaboração' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 3, label: 'Entregue ao EP' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 4, label: 'Revisão Interna' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 5, label: 'Gestão Técnica' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 6, label: 'Entregue ao Cliente' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
        <Step item={{ step: 7, label: 'Aprovado pelo Cliente' }}
          projeto={props.projeto}
          actual={count !== 0 ? prod.prodStatusActual_id : props.produto.prodStatusActual_id || 0}
          dataContratual={count !== 0 ? moment(prod.prod_dtContrato).format('DD/MM/YYYY') : moment(props.produto.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={count !== 0 ?  moment(prod.prodStatus3_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={count !== 0 ?  moment(prod.prodStatus4_data).format('DD/MM/YYYY') : moment(props.produto.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome ?? props.produto.prod_responsavelNomeAtual}
          prod_aprovCompliance={count !== 0 ? prod.prod_aprovCompliance : props.produto.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={count !== 0 ? prod.prodStatusAlt_obs : props.produto.prodStatusAlt_obs}
          produto={count !== 0 ? prod : props.produto}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
        />
      </Row>
    </>

  )
};

export default StepProgress;
